import MIDI from 'components/midi.vue';
import AnywhereParticipantList from 'components/anywhere/anywhere-participant-list.vue';
import AnywhereParticipant from 'components/anywhere/anywhere-participant.vue';
import AnywhereHost from 'components/anywhere/anywhere-host.vue';

export default function registerComponents(Vue){
    Vue.component('midi', MIDI);
    Vue.component('anywhere-participant-list', AnywhereParticipantList);
    Vue.component('anywhere-participant', AnywhereParticipant);
    Vue.component('anywhere-host', AnywhereHost);
}
